import { useState, useCallback, useEffect } from "react";
import { Auth, useAuthedRequest } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";

export function useExternal({ page = 1, limit = 15 }) {
  const { makeAuthedRequest } = Auth.useContainer();

  const { logError } = useLogger({ prefix: "useExternal" });
  const [requestId, setRequestId] = useState(0);
  const [records, setRecords] = useState(null);
  const [isWaiting, setIsWaiting] = useState(false);

  const { data, loading, error } = useAuthedRequest(
    `/v1/membership/loa/external?page=${page}&limit=${limit}&req=${requestId}`
  );

  const refresh = useCallback(() => {
    setRequestId(requestId + 1);
  }, [requestId]);

  useEffect(() => {
    if (data != null) {
      setRecords(data);
    }
  }, [data]);

  return {
    records,
    loading,
    isWaiting,
    refresh,
  };
}
